import { syncCamera } from "./main6.mjs";
import { useFunction } from "./main13.mjs";
function useRender(origin, r3mRef, frameloop) {
  const render = useFunction((_gl, mapCamMx) => {
    const r3m = r3mRef.current;
    if (!r3m.state || !r3m.map)
      return;
    const camera = r3m.state.camera;
    const gl = r3m.state.gl;
    const advance = r3m.state.advance;
    r3m.mapCamMx = mapCamMx;
    syncCamera(camera, origin, mapCamMx);
    gl.resetState();
    advance(Date.now() * 1e-3, true);
    if (frameloop === "always")
      r3m.map.triggerRepaint();
  });
  return render;
}
export {
  useRender
};
//# sourceMappingURL=main11.mjs.map
